import styled from 'styled-components'

type SimpleTextCardProps = {
  title: string,
  text: string,
  card?: boolean
}

const Wrapper = styled.div<{ $card: boolean }>`
  width: 100%;
  box-sizing: border-box;
  background-color: ${({ theme, $card }) => $card ? theme.colors.light : theme.colors.background2};
  border-radius: ${({ theme }) => theme.border.radius.base};
  box-shadow: ${({ theme, $card}) => $card ? theme.shadow.s2 : 'none' };
  padding: 0.5rem 1.3rem;
  line-height: 1.7rem;
  margin-bottom: ${({ theme }) => theme.spacing.md};
  & > h2 {
    font-size: ${({ theme }) => theme.typography.fontSize.s5};
    font-weight: 600;
  }
  & > p {
    font-size: ${({ theme }) => theme.typography.fontSize.s5};
    font-weight: 300;
  }
`

export const SimpleTextCard = ({ title, text, card = false }: SimpleTextCardProps) => {
  return (
    <Wrapper $card={card}>
      <h2>{title}</h2>
      <p>{text}</p>
    </Wrapper>
  )
}